if (!customElements.get('natunora-sticky-return')) {
  customElements.define('natunora-sticky-return', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.hidden = true;
      this.target = document.querySelector('#offer-purchase');
      this.trigger = document.querySelector('#natunora-transformation .n-transformation__row--desired');
      if (!this.target || !this.trigger) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const bar = this.querySelector('.n-sticky-return__bar');
      const update = () => {
        this.frame = null;
        this.hidden = this.target.getBoundingClientRect().bottom > 0 || this.trigger.getBoundingClientRect().top > window.innerHeight * .78;
        if (!this.hidden) this.style.setProperty('--n-sticky-height', `${bar.offsetHeight}px`);
      };
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', schedule, { ...options, passive: true });
      window.addEventListener('resize', schedule, options);
      window.addEventListener('pageshow', schedule, options);
      document.addEventListener('shopify:section:load', () => this.connectedCallback(), options);
      this.resize = new ResizeObserver(schedule);
      this.resize.observe(document.body);
      this.resize.observe(bar);
      const announcement = document.querySelector('.natunora-announcement__text');
      const syncOffer = () => {
        const text = (announcement?.getAttribute('data-sticky-copy') ?? announcement?.textContent ?? '').trim();
        const discount = text.match(/(\d+(?:[.,]\d+)?)\s*%\s*(Rabatt|sparen)/i);
        this.querySelector('[data-sticky-offer-full]').textContent = text;
        this.querySelector('[data-sticky-offer-short]').textContent = discount ? `${discount[1]} % ${discount[2].toLowerCase() === 'rabatt' ? 'Rabatt' : 'sparen'}` : text;
        const gift = (announcement?.getAttribute('data-sticky-gift') || '').trim();
        const giftNode = this.querySelector('[data-sticky-offer-gift]');
        if (giftNode) {
          giftNode.textContent = gift ? `+ ${gift}` : '';
          giftNode.hidden = !text || !gift;
        }
        this.querySelector('[data-sticky-offer]').hidden = !text;
        schedule();
      };
      if (announcement) {
        this.offerObserver = new MutationObserver(syncOffer);
        this.offerObserver.observe(announcement, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-sticky-copy', 'data-sticky-gift'] });
      }
      syncOffer();
      const track = (event) => {
        if (event.type === 'auxclick' && event.button !== 1) return;
        if (event.type === 'click' && event.button !== 0) return;
        if (!event.target.closest('[data-natunora-sticky-return-cta]')) return;
        try {
          if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.clarity === 'function') window.clarity('event', 'natunora_sticky_return_offer_click');
        } catch (_) {}
      };
      for (const event of ['click', 'auxclick']) this.addEventListener(event, track, { ...options, capture: true });
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.offerObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
